module.exports = __webpack_public_path__ + "img/9791155093009.e699836d.jpg";